import Glide from "@glidejs/glide"
import ArrowDisabler from "./arrow_disabler";

export default class GenericSlider {
    constructor(selector) {
        try {
            this.initObserver(selector)
        } catch (e) {
            document.body.addEventListener('intersection-observer-loaded', () => {
                this.initObserver(selector)
            })
        }

        document.body.addEventListener('product-recommendations-loaded', (e) => {
            this.initObserver(selector)
        })

        document.body.addEventListener('variant-changed', (event) => {
            const sliders = document.querySelectorAll(`.js-product-gallery[data-generic-slider*="-product-gallery-"]`)
            if (sliders) {
                sliders.forEach((el) => {
                    const sliderId = el.dataset.genericSlider
                    const glide = new Glide(el, event)
                    glide.mount()
                    glide.go(`=0`);
                    glide.on('run.after', () => {
                        window.pauseAllMedia()
                        this.initActiveSlideId(el, glide)
                    })
                    window.glideInstances = window.glideInstances || {};
                    window.glideInstances[sliderId] = glide;
                })
            }
        })

        document.addEventListener('shopify:section:load', (event) => {
            const slideshow = event.target.closest('.slideshow')
            if (slideshow) {
                const slider = slideshow.querySelector('[data-generic-slider]')
                if (slider) {
                    const sliderId = slider.dataset.genericSlider
                    const glide = new Glide(slider, {})
                    glide.mount()
                    glide.go(`=0`);
                    glide.on('run.after', () => {
                        window.pauseAllMedia()
                        this.initActiveSlideId(slider, glide)
                    })
                    window.glideInstances = window.glideInstances || {};
                    window.glideInstances[sliderId] = glide;
                }
            }
        });

        document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((el) => {
            el.addEventListener('shown.bs.tab', () => {
                const targetId = el.dataset.bsTarget.replace('#', '')
                const targetEl = document.getElementById(targetId)
                if (targetEl) {
                    const slider = targetEl.querySelector('[data-generic-slider]')
                    if (!slider.classList.contains('glide--swipeable')) {
                        const slidesNum = slider.querySelectorAll('.glide__slide')
                        if (slidesNum) {
                            const glide = new Glide(slider, window.glide_options[slider.dataset['genericSlider']]);
                            glide.mount({ArrowDisabler})
                        }
                    }
                }

            })
        })
    }

    initObserver(selector) {
        const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            threshold: 0
        });
        document.querySelectorAll(selector).forEach(el => {
            observer.observe(el);
        });
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains('glide--carousel')) {
                    return
                }
                setTimeout(() => {
                    this.initSlider(entry.target);
                }, 1);
            }
        })
    }

    showArrowsWhenNeeded(arrows, glide) {
        if (glide.numSlides == null) return;

        if (!arrows) return;

        if (glide.numSlides <= glide.settings.perView) {
            arrows.style.display = 'none';
        } else {
            arrows.style.display = '';
        }
    }

    initActiveSlideId(el, glide) {
        const activeSliderCounter = el.querySelector('.js-gallery-active-slide')
        const activeSlideId = glide.index + 1
        if (activeSliderCounter) {
            activeSliderCounter.textContent = activeSlideId
        }
    }

    initSlider(el) {
        if (!window.glide_options || !window.glide_options[el.dataset['genericSlider']]) {
            return
        }

        if (el.classList.contains('glide--swipeable')) {
            return
        }

        const glide = new Glide(el, window.glide_options[el.dataset['genericSlider']]);
        glide.numSlides = el.dataset['numSlides'] !== undefined ? parseInt(el.dataset['numSlides']) : null;

        /* do not initialize sliders with insufficient number of slides */
        if (glide.numSlides && glide.numSlides <= glide.settings.perView) return

        const arrows = glide.selector.querySelector('.glide__arrows')

        glide.on('resize', () => {
            this.showArrowsWhenNeeded(arrows, glide);
        });

        glide.on('mount.after', () => {
            this.showArrowsWhenNeeded(arrows, glide);
        });

        glide.mount({ArrowDisabler})

        window.glideInstances = window.glideInstances || {};
        window.glideInstances[el.dataset['genericSlider']] = glide;
        const event = new CustomEvent('glide-initialized', {detail: glide})
        document.body.dispatchEvent(event)

        glide.on('run.after', () => {
            window.pauseAllMedia()
            this.initActiveSlideId(el, glide)
        })
    }
}